<template>
    <div class="content">
        <p class="title">{{value.title}}</p>
        <div ref="echart" class="echart"></div>
    </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'theLineChart',
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    'value': {
      handler (newValue) {
        if (newValue) {
          setTimeout(() => {
            if (!this.echart) {
              this.echart = echarts.init(this.$refs['echart'])
              this.echart.setOption(
                this.option
              )
              window.addEventListener('resize', () => {
                this.echart.resize()
              })
            }
            this.changeEchart()
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      echart: null,
      option: {
        color: '#208EFF',
        grid: {
          top: 20,
          left: 10,
          right: '5%',
          bottom: 10,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              color: '#fff'
            }
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {color: '#909399'}
          },
          axisTick: {
            show: false
          },
          nameTextStyle: {
            fontSize: 11
          },
          data: [],
          axisLabel: {}
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            color: '#909399',
            formatter: function (value, index) {
              if ((index % 2) === 0) {
                return value
              } else if (isNaN(index)) {
                return value
              } else {
                return ''
              }
            }
          },
          axisLine: {
            lineStyle: {color: '#909399'}
          },
          axisTick: {
            show: false
          },
          nameTextStyle: {
            fontSize: 11
          }
        },
        series: [{
          data: [],
          type: 'line',
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: [
                {offset: 0, color: '#fff'},
                {offset: 1, color: '#208EFF'}
              ]
            },
            origin: 'start'
          }
        }]
      }
    }
  },
  methods: {
    changeEchart () {
      this.echart.setOption({
        xAxis: this.value.data.xAxis,
        yAxis: this.value.data.yAxis,
        series: this.value.data.series
      })
    }
  }
}
</script>

<style lang="scss" scoped>
    .content {
        position: relative;
    }

    .echart {
        width: 100%;
        height: 100%;
    }

    .title {
        position: absolute;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 12px;
        color: #aaa;
    }


    .title {
        top: 0;
        color: #343A40;
        width: 100%;
        text-align: center;
    }
</style>
